import React from "react";

import {
  Snackbar,
  Alert,
  Paper,
  Stack,
  InputAdornment,
  AlertTitle,
  Typography,
  Popper,
  FormControl,
  MenuItem,
  CircularProgress,
  Select,
  Modal,
  Button,
  Box,
  IconButton,
  Popover,
  Tooltip,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  TableHead,
  Checkbox,
  FormControlLabel,
} from "@mui/material";

import "./styles.css";

export default function MainButton({
  className,
  onClick,
  startIcon,
  endIcon,
  size="medium",
  small,
  color = "secondary",
  label,
  shadow = true,
  disabled = false,
}) {
  return (
    <div className={"button-outer " + className}>
      <Button
        variant="contained"
        onClick={onClick}
        color={color}
        startIcon={startIcon && <div className="button-icon">{startIcon}</div>}
        endIcon={endIcon && <div className="button-icon">{endIcon}</div>}
        type="submit"
        disabled={disabled}
        className={
          "main-btn " +
          (small && "small-btn") +
          (!shadow && " no-shadow") +
          (!color && " btn-no-color-set") * " "
          + ' btn-size-'+size
        }
      >
        <span className="px-1 text">{label}</span>
      </Button>
    </div>
  );
}
